import { render, staticRenderFns } from "./DrugCatalogsComponent.vue?vue&type=template&id=82d709d0"
import script from "./DrugCatalogsComponent.vue?vue&type=script&lang=js"
export * from "./DrugCatalogsComponent.vue?vue&type=script&lang=js"
import style0 from "./DrugCatalogsComponent.vue?vue&type=style&index=0&id=82d709d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports